import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api, bar, go, money, placeText, projectMeta, STATUS_TONE, communityOpen } from './util';

/** A project as a card: name, place, status, progress and (for fundraising) money raised */
export function ProjectCard(p) {
  const f = p.funding || {};
  const href = '/projects/' + p.slug;
  return m("a", {
    className: "VProj-card",
    href: href,
    onclick: go(href)
  }, m("span", {
    className: "VProj-cardTop"
  }, m("span", {
    className: "VProj-status",
    style: {
      color: STATUS_TONE[p.status]
    }
  }, p.statusLabel), m("span", {
    className: "VProj-kind"
  }, p.kindLabel), p.visibility === 'draft' ? m("span", {
    className: "VProj-draft"
  }, "Waiting for a second person") : null, p.type === 'personal' ? m("span", {
    className: "VProj-badge"
  }, p.visibility === 'private' ? 'Private' : 'Personal') : null), m("strong", {
    className: "VProj-cardName"
  }, p.name), m("span", {
    className: "VProj-place"
  }, m("i", {
    className: "fas fa-location-dot",
    "aria-hidden": "true"
  }), " ", placeText(p)), p.summary ? m("span", {
    className: "VProj-summary"
  }, p.summary) : null, m("span", {
    className: "VProj-meters"
  }, m("span", {
    className: "VProj-meter"
  }, m("small", null, "Progress"), bar(p.progress, '#1b4540'), m("b", null, p.progress, "%")), p.kind !== 'monitoring' && f.required > 0 ? m("span", {
    className: "VProj-meter"
  }, m("small", null, p.type === 'personal' ? 'Saved' : 'Raised'), bar(f.percent, '#b45309'), m("b", null, money(f.received, p.currency, true), " of ", money(f.required, p.currency, true))) : null), m("span", {
    className: "VProj-cardFoot"
  }, p.peopleCount, " ", p.peopleCount === 1 ? 'person' : 'people', " \xB7 ", p.followerCount, " following", p.type === 'personal' ? '' : ' · ' + p.vouchCount + ' ' + (p.vouchCount === 1 ? 'vouch' : 'vouches')));
}

/**
 * /projects: community projects in Nigeria's states (and personal projects their owners made public). Filters (type,
 * state, status, kind, words), the member's own projects (personal ones too, private included) and invitations on top,
 * and Start a project (community or personal).
 */
export default class ProjectList extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.f = {
      type: communityOpen() ? 'community' : 'personal',
      stateSlug: m.route.param('state') || '',
      status: '',
      kind: '',
      q: ''
    };
    this.q = '';
    this.list = null;
    this.total = 0;
    this.mine = null;
    this.load();
    if (app.session.user) {
      app.request({
        method: 'GET',
        url: api('/me/projects'),
        errorHandler: () => {}
      }).then(r => this.mine = r && r.projects || []).catch(() => this.mine = []).then(() => m.redraw());
    }
  }
  load(more) {
    const params = Object.assign({}, this.f, {
      offset: more ? this.list.length : 0
    });
    Object.keys(params).forEach(k => params[k] === '' && delete params[k]);
    this.loading = true;
    app.request({
      method: 'GET',
      url: api('/projects') + '?' + new URLSearchParams(params).toString(),
      errorHandler: () => {}
    }).then(r => {
      this.list = (more ? this.list : []).concat(r && r.projects || []);
      this.total = r && r.total || 0;
    }).catch(() => this.list = this.list || []).then(() => {
      this.loading = false;
      m.redraw();
    });
  }
  set(k, v) {
    this.f[k] = v;
    this.load();
  }
  start(type) {
    if (!app.session.user) {
      const b = document.querySelector('.item-logIn .Button, .item-logIn button');
      if (b) b.click();
      return;
    }
    const q = [type === 'personal' ? 'type=personal' : null, this.f.stateSlug ? 'state=' + this.f.stateSlug : null].filter(Boolean).join('&');
    m.route.set('/projects/new' + (q ? '?' + q : ''));
  }
  view() {
    const meta = projectMeta() || {};
    const states = meta.states || [];
    const mine = (this.mine || []).filter(p => p.myStatus === 'invited' || p.visibility === 'draft' || p.type === 'personal');
    const select = (k, label, options) => m("select", {
      className: "FormControl VProj-filter",
      value: this.f[k],
      onchange: e => this.set(k, e.target.value),
      "aria-label": label
    }, m("option", {
      value: ""
    }, label), options.map(([v, n]) => m("option", {
      value: v
    }, n)));
    return m("div", {
      className: "VProj"
    }, m("div", {
      className: "VProj-intro"
    }, m("div", null, m("h2", null, "Projects"), communityOpen() ? m("p", {
      className: "VBiz-muted"
    }, "Community projects Voucha members run in Nigeria\u2019s states (what each needs and costs, what\u2019s been raised, its milestones and progress), and your own personal projects: a house, land, a business, with budgets and reminders.") : m("p", {
      className: "VBiz-muted"
    }, "Your own projects: a house, land, a business. Plan the milestones and what it needs and costs, with budgets, savings and reminders. Private unless you make them public.")), m("span", {
      className: "VProj-startBtns"
    }, communityOpen() ? m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-people-group",
      onclick: () => this.start('community')
    }, "Start a community project") : null, m(Button, {
      className: 'Button' + (communityOpen() ? '' : ' Button--primary'),
      icon: "fas fa-user-lock",
      onclick: () => this.start('personal')
    }, "Start a personal project"))), communityOpen() ? null : m("div", {
      className: "VProj-soon"
    }, m("i", {
      className: "fas fa-people-group",
      "aria-hidden": "true"
    }), m("div", null, m("strong", null, "Community projects ", m("em", {
      className: "VProj-soonTag"
    }, "Coming soon")), m("p", null, "Projects members run together in their state, a borehole, a classroom, a road repair, which anyone can follow, vouch for and join."))), mine.length ? m("div", {
      className: "VProj-mine"
    }, m("h3", null, "Yours"), mine.map(p => m("a", {
      className: "VBiz-mineRow",
      href: '/projects/' + p.slug,
      onclick: go('/projects/' + p.slug)
    }, m("strong", null, p.name), m("span", {
      className: "VBiz-muted"
    }, p.myStatus === 'invited' ? 'Invited · open to join' : p.visibility === 'draft' ? 'Waiting for a second person to join' : (p.visibility === 'private' ? 'Private' : 'Public') + ' personal project · ' + p.progress + '% · ' + money(p.funding.received, p.currency, true) + ' saved')))) : null, m("div", {
      className: "VProj-filters"
    }, m("form", {
      className: "VBiz-search",
      onsubmit: e => {
        e.preventDefault();
        this.set('q', this.q.trim());
      }
    }, m("i", {
      className: "fas fa-search",
      "aria-hidden": "true"
    }), m("input", {
      className: "FormControl",
      type: "search",
      placeholder: "Search projects",
      value: this.q,
      oninput: e => this.q = e.target.value
    })), m("select", {
      className: "FormControl VProj-filter",
      value: this.f.type,
      onchange: e => this.set('type', e.target.value),
      "aria-label": "Type"
    }, communityOpen() ? m("option", {
      value: "community"
    }, "Community projects") : null, m("option", {
      value: "personal"
    }, "Public personal projects"), communityOpen() ? m("option", {
      value: ""
    }, "All public projects") : null), select('stateSlug', 'All states', states.map(s => [s.slug, s.name])), select('status', 'Any status', (meta.statuses || []).map(s => [s.key, s.name])), select('kind', 'Any kind', (meta.kinds || []).map(s => [s.key, s.name]))), this.list === null ? m(LoadingIndicator, null) : this.list.length ? m("div", null, m("p", {
      className: "VBiz-count"
    }, this.total === 1 ? '1 project' : this.total + ' projects'), m("div", {
      className: "VProj-cards"
    }, this.list.map(p => ProjectCard(p))), this.list.length < this.total ? m(Button, {
      className: "Button VBiz-more",
      loading: this.loading,
      onclick: () => this.load(true)
    }, "More projects") : null) : m("div", {
      className: "VEvt VEvt-empty"
    }, m("i", {
      className: "fas fa-people-carry-box",
      "aria-hidden": "true"
    }), m("h3", null, "No projects here yet"), m("p", null, communityOpen() ? 'Start one with someone you trust: a borehole, a classroom, a road repair or a clinic’s equipment.' : 'Start your own: a house, land, a business or solar.'), m(Button, {
      className: "Button Button--primary",
      onclick: () => this.start(communityOpen() ? 'community' : 'personal')
    }, "Start a project")));
  }
}
flarum.reg.add('voucha-community', 'forum/projects/ProjectList', ProjectList);